import { Heading } from '@apia/theme';
import { usePanelIdentity } from '../common';
import { useYieldPanelIsReady } from '../splash/panels/PanelContext';

export const PanelNotFound = () => {
  const props = usePanelIdentity();

  useYieldPanelIsReady();

  return (
    <>
      <Heading>Panel not found: {props.panelType}</Heading>
    </>
  );
};
